module.exports = __webpack_public_path__ + "media/notification.650164eb.mp3";